import { Chart } from '@frontend/chart/types';

import { HOUR_DAY_HEATMAP_DAYS, HOUR_DAY_HEATMAP_HOURS } from '../../../../utils/to-hour-day-heatmap-series';

const rangeStart = new Date(Date.UTC(2026, 6, 27));

export const VENDING_REPLENISHMENT_TRANSACTION_VOLUME_HOUR_DAY_HEATMAP_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Replenishment volume',
            data: Array.from({ length: HOUR_DAY_HEATMAP_DAYS * HOUR_DAY_HEATMAP_HOURS }, (_, index) => {
                const dayIndex = Math.floor(index / HOUR_DAY_HEATMAP_HOURS);
                const hour = index % HOUR_DAY_HEATMAP_HOURS;
                const date = new Date(rangeStart);
                date.setUTCDate(rangeStart.getUTCDate() + dayIndex);
                date.setUTCHours(hour, 0, 0, 0);

                const weekdayBoost = dayIndex % 7 < 5 ? 1.3 : 0.4;
                const hourBoost = hour >= 7 && hour <= 11 ? 1.8 : hour >= 13 && hour <= 16 ? 1.2 : 0.3;
                const value = Math.max(0, Math.round((2 + Math.sin(dayIndex / 3) * 1.5 + Math.cos(hour / 4) * 2) * weekdayBoost * hourBoost));

                return {
                    label: date.toISOString(),
                    value
                };
            })
        }
    ]
};
